// removed by extract-text-webpack-plugin
module.exports = {"enter":"_2RN2D","enterActive":"_36WvQ","leave":"_1REGI"};


//////////////////
// WEBPACK FOOTER
// ./app/components/profile-page-layout/profile-page-layout-transition.scss
// module id = 1770
// module chunks = 0